import { useMemo } from 'react';

import cn from 'classnames';
import Cookies from 'js-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
import { ACCOUNT_ROUTES, ADMIN_ROUTES } from 'pages/private/Routes';
import c, { STATUS } from 'utils/constants';
import { ValidateRolePermission } from 'utils/providers/RolePermission';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import { ROUTE } from 'pages/public/Routes';
import { GlobalSidebar } from 'ui/components/nav/Menu';
import { useFeatureFlagContext } from 'utils/providers/FeatureFlag';
import { useSubscriptionContext } from 'utils/providers/Subscription';

import { useProvider } from '../../utils/providers/Provider';

const Menu = () => {
  const { state, dispatch } = useProvider();
  const {
    state: { featureFlags },
  } = useFeatureFlagContext();
  const {
    state: { isSubscribe: _isSubscribe },
  } = useSubscriptionContext();
  const location = useLocation();
  const navigate = useNavigate();

  const { collapse } = state;
  const toggleSidebar = () => {
    dispatch?.({ type: 'toggleSidebar' });
  };

  const {
    state: { isPreview },
  } = useAppWrapperContext();

  const routes = useMemo(() => {
    const accountRoutes = ACCOUNT_ROUTES.filter(
      ({ key, isSubscribe, isLocked }) => {
        if (!key) return true;

        if (!featureFlags) return false;

        if (!featureFlags[key]) return false;

        if (featureFlags[key].status !== STATUS.ACTIVE) return false;

        if (isSubscribe && !_isSubscribe && !isLocked) return false;

        return true;
      },
    ).filter(({ development, acl, hidden }) => {
      if (hidden) return false;

      if (!development) return ValidateRolePermission(acl);

      return development && import.meta.env.NODE_ENV === 'development';
    });

    if (isPreview) {
      return accountRoutes;
    }

    const role = Cookies.get('_role');

    if (
      c.ROLES[role as keyof typeof c.ROLES] &&
      c.ROLES.account === c.ROLES[role as keyof typeof c.ROLES]
    ) {
      return accountRoutes;
    }

    return ADMIN_ROUTES;
  }, [_isSubscribe, featureFlags, isPreview]);

  return (
    <div
      id="menu-wrapper"
      className={cn(
        'relative',
        'w-auto',
        'h-screen',
        'sticky top-0 left-0 z-50',
      )}
    >
      <GlobalSidebar
        toggleSidebar={toggleSidebar}
        collapse={collapse}
        defaultActive={location.pathname}
        defaultSubActive={location.pathname}
        routes={
          routes
            .map(({ subMenu, ...rest }): ROUTE => {
              if (!subMenu) return rest;

              const _subMenu = subMenu.filter(({ acl }) =>
                ValidateRolePermission(acl),
              );

              return {
                subMenu: _subMenu,
                ...rest,
              };
            })
            .map(({ subMenu, path, to, ...rest }) => {
              if (isPreview) {
                return {
                  ...rest,
                  path: path !== '/' ? path.slice(1) : '',
                  to: !!to && to.slice(1),
                  subMenu:
                    !!subMenu &&
                    subMenu.map((subRoute) => ({
                      ...subRoute,
                      path: subRoute.path.slice(1),
                    })),
                };
              }

              return { ...rest, subMenu, path, to };
            }) as ROUTE[]
        }
        onChange={(val) => navigate(val)}
      />
    </div>
  );
};

export default Menu;
